<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Koleksi Soal
        <div class="card-header-actions">
          <CLink href="#" class="card-header-action btn-setting">
            <a @click="addSoal">
              <CIcon name="cil-plus" />
            </a>
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <div style="overflow: inherit">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Code</th>
                <th>Mata Pelajaran</th>
                <th>Durasi Pengerjaan (menit)</th>
                <th>Jumlah Soal</th>
                <th style="width: 50px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in data.data" :key="k">
                <td class="center">{{ k + 1 }}</td>
                <td>{{ d.code }}</td>
                <td>{{ d.subject.name }}</td>
                <td>{{ d.duration }}</td>
                <td class="center">{{ d.count }}</td>
                <td class="action center">
                  <btn-edit @click="doEdit(d.id)" />
                  <btn-delete @click="doDelete(d.id)"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <content-pagination
          :page="paginate.page"
          :size="paginate.size"
          :total="paginate.total"
          @input="loadPage"
        />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import ContentPagination from "../../components/ContentPagination";
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
export default {
  components: {
    ContentPagination,
    BtnEdit,
    BtnDelete,
  },
  data() {
    return {
      data: {},
      paginate: {},
    };
  },
  created() {
    this.load("", 1);
  },
  methods: {
    load(year, page) {
      var qYear = "";
      if (year && year != "") {
        qYear = `year=${year}`;
      }
      HTTPAUTH.get(
        `/api/v1/admin/question-group?page=${page}&size=10&${qYear}`
      ).then((res) => {
        this.data = res.data;
        this.paginate = this.data.paginate;
      });
    },
    loadPage(page) {
      this.load("", page);
    },
    addSoal() {
      this.$router.push({ path: "/soal/tambah/new" });
    },
    changeYear(y) {
      const query = this.$route.query;
      if (query && query.page) {
        this.load(y.label, query.page);
        return;
      }
      this.load(y.label, 1);
    },
    doDelete(id) {
      HTTPAUTH.delete(
        `/api/v1/admin/question-group/${id}`
      ).then(() => {
        this.load("", 1)
      });
    },
    doEdit(id) {
      this.$router.push({ path: "/soal/tambah/" + id });
    },
  },
};
</script>